/**
 * Wrapper of MDC Ripple
 * @link https://github.com/material-components/material-components-web/tree/master/packages/mdc-ripple
 * @link https://material.io/develop/web/docs/framework-integration/
 */
define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'js/riq-ripple/1.0.0/dist/mdc.ripple.min',
  'text!js/riq-ripple/1.0.0/dist/mdc.ripple.min.css'
  /* eslint-enable */
], function riqRippleModule(app, MDCRipple, css) {
  'use strict';
  app.registerDirective('riqRipple', function (){
    return {
      restrict: 'A',
      bindToController: {
        unbounded: '@'
      },
      controller: 'riqRippleController',
      controllerAs: 'riqRippleCtrl'
    };
  });
  app.registerController('riqRippleController', [
    '$scope',
    '$element',
    'compileService',
    function riqRippleController($scope, $element, compileService) {
      var _this = this;      
      compileService.compile({css: css}, $scope, $element);
      _this.$element = $element;
      _this.mdlRippleComponent = null;

      _this.$postLink = function riqRipplePostLink() {
        this.mdlRippleComponent = new MDCRipple.MDCRipple(this.$element[0]);
        this.mdlRippleComponent.unbounded = this.unbounded === 'true'; 
        this.$element.addClass('mdc-ripple-surface');
      };
      
      $scope.$on('$destroy', function destroy() {
        if (_this.mdlRippleComponent && typeof _this.mdlRippleComponent.destroy === 'function') {
          _this.mdlRippleComponent.destroy();
        }
      });
    }
  ]);
});
